import { useNavigate } from 'react-router-dom';
import { useQuery, useMutation } from '@apollo/client';
import { Formik } from 'formik';
import Button from '../components/Button';
import { Field, FieldInput, FieldLabel } from '../components/Field';
import Loader from '../components/Loader';
import { Modal, ModalExit, ModalName, ModalPart } from '../components/Modal';
import { useToast } from '../components/Toast';
import { VIEWER } from '../utilities/queries';
import { UPDATE_VIEWER_NAME } from '../utilities/mutations';

const EditNameModal = () => {
  const navigate = useNavigate();
  const toast = useToast();
  const { loading, data } = useQuery(VIEWER);
  const [updateViewerName] = useMutation(UPDATE_VIEWER_NAME);

  const close = () => navigate('/settings/main');

  return (
    <Modal onClose={() => close()}>
      {loading ? (
        <ModalPart>
          <Loader />
        </ModalPart>
      ) : (
        <>
          <ModalExit />
          <ModalName>Edit name</ModalName>
          <Formik
            initialValues={{ name: data.viewer.name }}
            onSubmit={async (values) => {
              try {
                await updateViewerName({ variables: { name: values.name } });
              } catch (error) {
                toast({ children: error.message });

                return;
              }

              toast({ children: 'Name updated' });
              close();
            }}
          >
            {({
              values,
              handleChange,
              handleBlur,
              handleSubmit,
              isSubmitting,
            }) => (
              <form onSubmit={handleSubmit}>
                <ModalPart>
                  <Field>
                    <FieldLabel>Name</FieldLabel>
                    <FieldInput
                      type="name"
                      name="name"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.name}
                      data-autofocus
                    />
                  </Field>
                </ModalPart>
                <ModalPart>
                  <Button
                    type="submit"
                    disabled={values.name === data.viewer.name || isSubmitting}
                    isPrimary
                    isExtended
                  >
                    Save
                  </Button>
                </ModalPart>
              </form>
            )}
          </Formik>
        </>
      )}
    </Modal>
  );
};

export default EditNameModal;
